export const ADMIN_CREATE_BRAND_REQUEST = "ADMIN_CREATE_BRAND_REQUEST";
export const ADMIN_CREATE_BRAND_SUCCESS = "ADMIN_CREATE_BRAND_SUCCESS";
export const ADMIN_CREATE_BRAND_FAIL = "ADMIN_CREATE_BRAND_FAIL";

export const ADMIN_VIEW_BRAND_REQUEST = "ADMIN_VIEW_BRAND_REQUEST";
export const ADMIN_VIEW_BRAND_SUCCESS = "ADMIN_VIEW_BRAND_SUCCESS";
export const ADMIN_VIEW_BRAND_FAIL = "ADMIN_VIEW_BRAND_FAIL";

export const ADMIN_LIST_BRAND_REQUEST = "ADMIN_LIST_BRAND_REQUEST";
export const ADMIN_LIST_BRAND_SUCCESS = "ADMIN_LIST_BRAND_SUCCESS";
export const ADMIN_LIST_BRAND_FAIL = "ADMIN_LIST_BRAND_FAIL";

export const ADMIN_ALL_BRAND_REQUEST = "ADMIN_ALL_BRAND_REQUEST";
export const ADMIN_ALL_BRAND_SUCCESS = "ADMIN_ALL_BRAND_SUCCESS";
export const ADMIN_ALL_BRAND_FAIL = "ADMIN_ALL_BRAND_FAIL";

export const BRAND_DELETE_REQUEST = "BRAND_DELETE_REQUEST";
export const BRAND_DELETE_SUCCESS = "BRAND_DELETE_SUCCESS";
export const BRAND_DELETE_FAIL = "BRAND_DELETE_FAIL";

export const ADMIN_UPDATE_BRAND_REQUEST = "ADMIN_UPDATE_BRAND_REQUEST";
export const ADMIN_UPDATE_BRAND_SUCCESS = "ADMIN_UPDATE_BRAND_SUCCESS";
export const ADMIN_UPDATE_BRAND_FAIL = "ADMIN_UPDATE_BRAND_FAIL";

export const ADMIN_REMOVE_BRAND_REQUEST = "ADMIN_REMOVE_BRAND_REQUEST";
export const ADMIN_REMOVE_BRAND_SUCCESS = "ADMIN_REMOVE_BRAND_SUCCESS";
export const ADMIN_REMOVE_BRAND_FAIL = "ADMIN_REMOVE_BRAND_FAIL";

export const ADMIN_REFRESH_BRAND_REQUEST = "ADMIN_REFRESH_BRAND_REQUEST";
export const ADMIN_REFRESH_BRAND_SUCCESS = "ADMIN_REFRESH_BRAND_SUCCESS";
export const ADMIN_REFRESH_BRAND_FAIL = "ADMIN_REFRESH_BRAND_FAIL";
